import { DateTime } from 'luxon';

export type ReportPeriodType = 'month' | 'quarter' | 'year' | 'custom';

export interface ReportPeriodRange {
    start: DateTime;
    end: DateTime;
}

export const getPresetPeriodRange = (
    type: Exclude<ReportPeriodType, 'custom'>,
    now: DateTime = DateTime.now(),
): ReportPeriodRange => {
    switch (type) {
        case 'month':
            return { start: now.startOf('month'), end: now.endOf('month') };
        case 'quarter':
            return { start: now.startOf('quarter'), end: now.endOf('quarter') };
        case 'year':
            return { start: now.startOf('year'), end: now.endOf('year') };
    }
};

export const formatPeriodRange = (start: DateTime, end: DateTime): string =>
    `${start.toFormat('dd.MM.yyyy')} — ${end.toFormat('dd.MM.yyyy')}`;

export const periodRangeToMillis = (start: DateTime, end: DateTime): [number, number] => [
    start.startOf('day').toMillis(),
    end.endOf('day').toMillis(),
];
